import { render, staticRenderFns } from "./synopsis.vue?vue&type=template&id=ed8c7f08&scoped=true&"
import script from "./synopsis.vue?vue&type=script&lang=js&"
export * from "./synopsis.vue?vue&type=script&lang=js&"
import style0 from "./synopsis.vue?vue&type=style&index=0&id=ed8c7f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8c7f08",
  null
  
)

export default component.exports